import { useParams, useNavigate } from "react-router-dom";
import api from "../../../api/api";

export default function LegalEntityDeletePage() {
    const { id } = useParams();
    const navigate = useNavigate();

    const handleDelete = async () => {
        try {
            await api.delete(`/LegalEntity/${id}`);
            navigate("/admin/legal");
        } catch (err) {
            alert(
                err?.response?.data?.message ||
                err?.message ||
                "Failed to delete legal entity"
            );
        }
    };

    return (
        <div className="max-w-xl mx-auto p-6 bg-white rounded shadow">
            <h1 className="text-2xl font-bold mb-4">Delete Legal Entity</h1>

            <p className="mb-4">
                Are you sure you want to delete this legal entity?
            </p>

            <div className="flex gap-3">
                <button
                    onClick={handleDelete}
                    className="bg-red-600 text-white px-4 py-2 rounded"
                >
                    Delete
                </button>

                <button
                    onClick={() => navigate("/admin/legal")}
                    className="border px-4 py-2 rounded"
                >
                    Cancel
                </button>
            </div>
        </div>
    );
}